<script lang="ts">
	//Services
	import { format } from '../../../../services/i18n';
	import { gen2Request } from '../../../../services/gen_2_http_reqs';
	import { localReq, postReq } from '../../../../services/http';
	//Helpers
	import { get_local_ip, is_gen_2, real_id } from '../../../../helpers/interface_helpers';
	import { capFirstChar } from '../../../../helpers/utilities';
	//Stores
	import { rebooting_devices } from 'src/stores/device-runtime/process';
	//Components
	import ModalPrompt from '../../../ModalPrompt.svelte';
	//Design system components
	import { Button, Text, toast } from '@Shelly/shelly-design-system';

	export let device;
	let showModal = false;
	const id = real_id(device.id);
	const gen2 = is_gen_2(device);
	let localIp = get_local_ip(id);
	let loading = false;

	const rebootDevice = async () => {
		loading = true;
		let res;
		if (gen2) {
			res = await gen2Request(device, 'Shelly.Reboot', {});
		} else {
			if (localIp) {
				res = await localReq(device, `${localIp}/reboot`, 'post', {});
			} else {
				res = await postReq(`/device/reboot`, {
					id: id,
				});
			}
		}
		if (res.isok) {
			toast.open({ type: 'success', title: $format('reboot_scc_toast') });
			rebooting_devices.update(id);
		} else {
			toast.open({ type: 'danger', title: $format('reboot_err_toast') });
		}
		loading = false;
	};

	let props = {
		title: $format('reboot_device_title', { default: 'Reboot Device?' }),
		text: $format('reboot_device_info_text', {
			default:
				'Rebooting the device will restart its operating system, potentially resolving minor issues and improving overall performance. This action will briefly interrupt device functionality.',
		}),
		button_2: $format('button_cancel'),
		button_1: $format('button_reboot_device', { default: 'Reboot device' }),
		callback: rebootDevice,
	};
</script>

<Text styleType="body-small" class="mb-s">{$format('reboot_description')}</Text>

<Button {loading} size="m" width="full" on:click={() => (showModal = true)}
	>{capFirstChar($format('button_reboot'))}</Button
>
{#if showModal}
	<ModalPrompt bind:showModal {props} />
{/if}
